import { useEffect, useState } from "react";
import { Crown, Flame, TrendingUp, Coins, Gift, LockOpen } from "lucide-react";
import { api } from "@/lib/api";
import { UserAvatar, UserLink } from "@/components/UserBits";

const ago = (s) => {
  const m = Math.max(1, Math.round((Date.now() - new Date(s)) / 60000));
  return m < 60 ? `vor ${m} Min.` : `vor ${Math.round(m / 60)} Std.`;
};

function TickerText({ w }) {
  if (w.type === "level") return <span className="inline-flex items-center gap-1 font-bold text-fuchsia-300"><TrendingUp className="w-4 h-4" /> steigt auf Level {w.level} „{w.level_name}“ auf</span>;
  if (w.type === "goldrain") return <span className="inline-flex items-center gap-1 font-bold text-amber-300"><Coins className="w-4 h-4" /> gewinnt den Goldregen mit {w.coins} Münzen</span>;
  if (w.type === "vault") return <span className="inline-flex items-center gap-1 font-extrabold text-amber-300"><LockOpen className="w-4 h-4" /> knackt den Goldenen Tresor: +{w.points}!</span>;
  if (w.type === "redeem") return <span className="inline-flex items-center gap-1 font-bold text-emerald-300"><Gift className="w-4 h-4" /> hat {w.reward} eingelöst</span>;
  return w.jackpot
    ? <span className="inline-flex items-center gap-1 font-extrabold text-amber-300"><Crown className="w-4 h-4 fill-amber-400" /> knackt den JACKPOT: +{w.points}!</span>
    : <span className="inline-flex items-center gap-1 font-bold text-pink-300"><Flame className="w-4 h-4 fill-orange-500 text-orange-400" /> Wochenend-Gewinn +{w.points}</span>;
}

export function WinnerTicker() {
  const [wins, setWins] = useState([]);
  useEffect(() => {
    const load = () => api.get("/wheel/big-wins").then(({ data }) => setWins(data)).catch(() => {});
    load();
    const iv = setInterval(() => document.visibilityState === "visible" && load(), 30000);
    window.addEventListener("points-changed", load);
    return () => { clearInterval(iv); window.removeEventListener("points-changed", load); };
  }, []);
  if (!wins.length) return null;
  const items = [...wins, ...wins];
  return (
    <div className="relative overflow-hidden rounded-2xl bg-slate-900 text-white border border-amber-400/40" data-testid="winner-ticker">
      <div className="absolute left-0 inset-y-0 z-10 flex items-center gap-1.5 pl-3 pr-3 bg-slate-900 shadow-[14px_0_14px_-2px_#0f172a] text-[10px] font-extrabold uppercase tracking-widest text-amber-300">
        <span className="w-2 h-2 rounded-full bg-rose-500 animate-pulse" /> Live
      </div>
      <div className="flex gap-10 py-2.5 pl-20 w-max ticker-run" style={{ animationDuration: `${Math.max(12, wins.length * 7)}s` }}>
        {items.map((w, i) => (
          <span key={i} className="inline-flex items-center gap-2 text-sm whitespace-nowrap" data-testid={i < wins.length ? `winner-ticker-item-${i}` : undefined}>
            <UserAvatar userId={w.user_id} name={w.name} picture={w.picture} size="w-6 h-6" text="text-[10px]" />
            <UserLink id={w.user_id} className="font-bold">{w.name}</UserLink>
            <TickerText w={w} />
            <span className="text-xs text-white/50">{ago(w.created_at)}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
